module.exports = __webpack_public_path__ + "img/miryoku4.2866ee68.jpg";